import { APP_SPECTRUM_GRADIENT } from "components/ui/v2/composites/app-spectrum-gradient";
import { useTemplateContext } from "context/template/TemplateContext";
import { TemplateType } from "stores/template/useTemplateStore";

const spectrumBandStyles = `
  height: 8.5rem;
  max-height: 180px;
  pointer-events: none;
  background: ${APP_SPECTRUM_GRADIENT};
  background-size: 300% 100%;
  background-position: var(--site-spectrum-start-x, 0%) 50%;
  opacity: 0.3;
  animation-name: site-spectrum-bg-shift;
  animation-duration: var(--site-spectrum-duration, 18s);
  animation-timing-function: var(--site-spectrum-easing, linear);
  animation-iteration-count: var(--site-spectrum-iterations, infinite);
  animation-fill-mode: var(--site-spectrum-fill, none);
  -webkit-mask-image: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 1) 0%,
    rgba(0, 0, 0, 1) 22%,
    rgba(0, 0, 0, 0.94) 40%,
    rgba(0, 0, 0, 0.82) 56%,
    rgba(0, 0, 0, 0.64) 70%,
    rgba(0, 0, 0, 0.44) 82%,
    rgba(0, 0, 0, 0.24) 91%,
    rgba(0, 0, 0, 0.1) 96%,
    transparent 100%
  );
  mask-image: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 1) 0%,
    rgba(0, 0, 0, 1) 22%,
    rgba(0, 0, 0, 0.94) 40%,
    rgba(0, 0, 0, 0.82) 56%,
    rgba(0, 0, 0, 0.64) 70%,
    rgba(0, 0, 0, 0.44) 82%,
    rgba(0, 0, 0, 0.24) 91%,
    rgba(0, 0, 0, 0.1) 96%,
    transparent 100%
  );
`;

/**
 * Degradé espectral al inicio del scroll (`.site-spectrum-band`).
 */
export default function SiteSpectrumBackgroundStyles() {
  const { template } = useTemplateContext();

  if (template === TemplateType.Classic) {
    return null;
  }

  return (
    <style jsx global>{`
      @keyframes site-spectrum-bg-shift {
        0% {
          background-position: var(--site-spectrum-start-x, 0%) 50%;
        }
        100% {
          background-position: var(--site-spectrum-end-x, 300%) 50%;
        }
      }

      .site-spectrum-band-wrap {
        position: relative;
        z-index: 0;
        height: 0;
        width: 100%;
        min-width: 100%;
        flex-shrink: 0;
        overflow: visible;
      }

      .site-spectrum-band {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        z-index: 0;
        width: 100%;
        ${spectrumBandStyles}
      }

      .dark .site-spectrum-band {
        opacity: 0.24;
      }

      .site-spectrum-scroll::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        z-index: 0;
        ${spectrumBandStyles}
      }

      .dark .site-spectrum-scroll::before {
        opacity: 0.24;
      }

      @media (prefers-reduced-motion: reduce) {
        .site-spectrum-band,
        .site-spectrum-scroll::before {
          animation: none;
          background-position: 50% 50%;
        }
      }
    `}</style>
  );
}
